import * as React from "react"
import type { SVGProps } from "react"
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.333 3.958c-.575 0-1.041.467-1.041 1.042v10c0 .575.466 1.042 1.041 1.042h13.334c.575 0 1.041-.467 1.041-1.042V5c0-.575-.466-1.042-1.041-1.042zM1.042 5a2.292 2.292 0 0 1 2.291-2.292h13.334A2.292 2.292 0 0 1 18.958 5v10a2.292 2.292 0 0 1-2.291 2.292H3.333A2.292 2.292 0 0 1 1.042 15z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M1.14 5.498a.625.625 0 0 1 .862-.192l7.473 4.749a.991.991 0 0 0 1.05 0l.002-.001 7.471-4.748a.625.625 0 1 1 .67 1.055l-7.478 4.752a2.242 2.242 0 0 1-2.38 0l-.004-.002-7.475-4.75a.625.625 0 0 1-.192-.863"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMail
